export const translations = {
	'Compass': {
		no: 'Kompass',
	},
	'Appearance': {
		no: 'Utseende',
	},
	'Radial': {
		no: 'Radial',
	},
	'Labels count': {
		no: 'Merke antall',
	},
	'Tick labels position': {
		no: 'Posisjon for merker',
	},
	'Inside': {
		no: 'Innside',
	},
	'Outside': {
		no: 'Utside',
	},
	'Direction labels position': {
		no: 'Posisjon for retningsmerker',
	},
	'Background color': {
		no: 'Bakgrunnsfarge',
	},
	'Background color type': {
		no: 'Type bakgrunnsfarge',
	},
	'Background end color': {
		no: 'Sluttfarge for bakgrunn',
	},
	'Gradient direction': {
		no: 'Gradientretning',
	},
	'Axis color': {
		no: 'Aksefarge',
	},
	'Indicator color': {
		no: 'Pekerfarge',
	},
	'Metric name color': {
		no: 'Farge på metrikknavn',
	},
	'Metric name position': {
		no: 'Posisjon for metrikknavn',
	},
	'Radial Gauge': {
		no: 'Sirkulær måler',
	},
	'Invert dial direction': {
		no: 'Inverter retning',
	},
	'Direction label': {
		no: 'Retningsmerke',
	},
	'Tick label': {
		no: 'Aksemerke',
	},
	'Clear selection': {
		no: 'Nullstill',
	},
};
